<template>
    <header class="app-header" role="banner">
        <div class="header-spacer"></div>
        <div class="header-logo">
            <Logo />
        </div>
        <div class="header-actions">
            <button
                v-if="showBell"
                type="button"
                class="bell-btn"
                aria-label="Últimos documentos"
                @click="$emit('bell-click')"
            >
                <Bell v-if="!hasNewDocs" />
                <BellNotification v-else />
            </button>
        </div>
    </header>
</template>

<script>
import Bell from "@/components/svg/Bell.vue";
import BellNotification from "@/components/svg/BellNotification.vue";
import Logo from "@/components/svg/Logo.vue";

export default {
    name: "AppHeader",
    components: { Bell, BellNotification, Logo },
    props: {
        // Controla si la campana se renderiza. El padre decide la lógica
        // (e.g., user logged + sección distinta a conciliador).
        showBell: { type: Boolean, default: false },
        // Toggle entre Bell (sin docs nuevos) y BellNotification (con docs).
        hasNewDocs: { type: Boolean, default: false },
    },
};
</script>

<style lang="scss" scoped>
.app-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 60;
    height: var(--chrome-h, 56px);
    background-color: var(--sidebar-paper, #ffffff);
    // Separador estructural: rule line + whisper-quiet shadow para diferenciar
    // del contenido scrolleable que pasa por debajo. Border solo se nota cuando
    // hay contraste contra el bg de la vista; el shadow asegura la separación
    // cuando ambos son paper-soft.
    border-bottom: 1px solid var(--sidebar-rule, rgba(16, 24, 40, 0.08));
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
    display: grid;
    // 1fr (spacer izquierdo, queda cubierto por sidebar via z-index) |
    // auto (logo centrado) | 1fr (actions a la derecha).
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    padding: 0 16px;
    gap: 12px;
}

.header-logo {
    justify-self: center;
    display: flex;
    align-items: center;
    // Crece hasta dejar 8px de padding arriba/abajo dentro del header
    // (--chrome-h = 56px → 40px de logo). Si se sube más se siente
    // apretado contra el border-bottom.
    height: 40px;
    max-height: calc(var(--chrome-h, 56px) - 16px);
    min-width: 0;

    > svg {
        height: 100%;
        width: auto;
        max-width: 100%;
    }
}

.header-actions {
    justify-self: end;
    display: flex;
    align-items: center;
    gap: 8px;
}

.bell-btn {
    width: 36px;
    height: 36px;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: 1px solid var(--sidebar-rule, rgba(16, 24, 40, 0.08));
    border-radius: var(--sidebar-radius, 6px);
    cursor: pointer;
    transition: background-color var(--app-transition-fast);

    &:hover {
        background-color: var(--sidebar-hover, rgba(16, 24, 40, 0.03));
    }

    &:focus-visible {
        outline: 2px solid var(--sidebar-accent, #0d5154);
        outline-offset: 2px;
    }
}
</style>
